import {entityService} from '@/services'

export const EntityNames = {


  async getStatusName(name) {
    try {
      let res = await entityService.getEntities()
      for (const item of res) {
        if (item.name === name) return item.id
      }
    } catch (e) {
      return e
    }
  },

  async getStatusId(id) {
    try {
      let res = await entityService.getEntities()
      for (const item of res) {
        if (item.id === id) return item.name
      }
    } catch (e) {
      return e
    }
  },

  async setStatus(name) {
    try {
      let res = await entityService.getEntities()
      for (const item of res) {
        if (item.name === name) return item.id
      }
    } catch (e) {
      return e
    }
  },

  async getStatus(id) {
    try {
      let res = await entityService.getEntities()
      for (const item of res) {
        if (item.id === id) return item.name
      }
    } catch (e) {
      return e
    }
  },

}